export const columns: any[] = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'left',
    width: 80,
  },
  {
    title: '发生时间',
    dataIndex: 'operateTimestamp',
    align: 'left',
    width: 150,
  },
  {
    title: '事件',
    dataIndex: 'alarmEvent',
    align: 'left',
    width: 150,
  },
  {
    title: '问题描述',
    dataIndex: 'description',
    align: 'left',
    ellipsis: true,
    width: 200,
  },
  {
    title: '持续时间',
    dataIndex: 'eventDuration',
    align: 'left',
    width: 150,
  },
];
